"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Can = exports.AbilityContext = void 0;
var react_1 = require("@casl/react");
var react_2 = require("react");
exports.AbilityContext = (0, react_2.createContext)(null);
exports.Can = (0, react_1.createContextualCan)(exports.AbilityContext.Consumer);
//# sourceMappingURL=ability.js.map